import React, {useEffect} from 'react'
import '../styles/Faq.css'

const Faq = () => {


  return (
    <div className='faq-container'>
      <br /><br /><br /><br />
      <h1> Frequently Asked Questions</h1>

      <br />
      <h3> How to create the Model?</h3>
      <p> If your model has been created using Python, you 
        will have to first convert it to TFJS model format. 
        For that you would have to use the tfjs-converter. </p>

      <br />
      <h3> How do I upload/load the model?</h3>
      <p> For the model to work, you would have to ensure 
        that you upload a model.json file and 7 other bin files. 
        You can use the default model if you do not have the model 
        with you. </p>

      <br />
 
    </div>
  )
}

export default Faq
